import {
    LocationIntegrationContract,
    OrderLookupContract,
    ProductSlimModel,
} from 'models'
import {
    getOrderQueuesActions,
    ORDER_QUEUE_ADD_ORDER,
    ORDER_QUEUE_CLEAR,
    ORDER_QUEUE_UPDATE_ORDER_STATUS,
    ORDER_QUEUE_UPDATE_PAYMENT_STATUS,
} from 'store/actions/orderQueue.action'
import { IAction } from 'types/storeTypes'

interface IOrderQueueState {
    loading: boolean
    orders: OrderLookupContract[]
    products: ProductSlimModel[]
    configuredIntegrationIds: number[]
}

const initialState: IOrderQueueState = {
    loading: false,
    orders: [],
    products: [],
    configuredIntegrationIds: [],
}

function orderQueueReducer(
    state: IOrderQueueState = initialState,
    action: IAction,
): IOrderQueueState {
    switch (action.type) {
        case getOrderQueuesActions.onPending:
            return {
                ...state,
                loading: true,
            }
        case getOrderQueuesActions.onSuccess:
            return {
                ...state,
                orders: action.payload.orders,
                products: action.payload.products,
                configuredIntegrationIds: (action.payload
                    .locationIntegrations as LocationIntegrationContract[])
                    .filter((l) => l.isConfigured)
                    .map((l) => l.integrationID!!),
                loading: false,
            }
        case getOrderQueuesActions.onFailed:
            return {
                ...state,
                loading: false,
            }
        case ORDER_QUEUE_ADD_ORDER:
            // don't add if order already
            const newData = action.payload as OrderLookupContract
            const currentOrder = state.orders.find(
                (o) => o.orderID === newData.orderID,
            )
            if (currentOrder) return state

            return {
                ...state,
                orders: [...state.orders, newData],
            }
        case ORDER_QUEUE_UPDATE_ORDER_STATUS: {
            const newData = action.payload as OrderLookupContract
            const currentIndex = state.orders.findIndex(
                (o) => o.orderID === newData.orderID,
            )
            if (currentIndex < 0) return state
            state.orders[currentIndex].status = newData.status

            return {
                ...state,
                orders: [...state.orders],
            }
        }
        case ORDER_QUEUE_UPDATE_PAYMENT_STATUS: {
            const newData = action.payload as OrderLookupContract
            const currentOrder = state.orders.find(
                (o) => o.orderID === newData.orderID,
            )
            if (!currentOrder) return state

            currentOrder.orderPaymentStatus = newData.orderPaymentStatus
            currentOrder.paymentTypeId = newData.paymentTypeId
            currentOrder.useMultiplePaymentType = newData.useMultiplePaymentType

            return {
                ...state,
                orders: [...state.orders],
            }
        }
        case ORDER_QUEUE_CLEAR:
            return {
                ...state,
                orders: [],
            }
        default:
            return state
    }
}

export default orderQueueReducer
